/* eslint-disable */
import './header';
import './search';
import './poll';
import {showElement, HideElement, toggleElement, AnchorScroll, CreateFormData, Collapsible, ToTop} from './utils';
import {defer_images, instant_defer} from './img-defer';
import {initPollResults, initUpdatePoll, loadPoll} from './poll';
import {Cookie} from './cookie';
import {Toast} from './toast';
window.addEventListener('load', () => {

    defer_images();

    Collapsible();

    new ToTop('.btn--top');

    document.addEventListener('change', e => {
        if (!e.target.closest('.poll-container input')) return;
        const closest_el = e.target.closest('.poll-container input'),
            btn_vote = closest_el.parentElement.parentElement.querySelector('[disabled]');
        btn_vote && btn_vote.removeAttribute('disabled');
    });


    document.addEventListener('click', e => {
        if (e.target.closest('.poll-container .btn--vote')) {
            const form = e.target.closest('.poll-container');//.dataset.poll;
            const answerId = document.querySelector('.form-group.custom__radio input:checked').id;
            const answerValue = document.querySelector('.form-group.custom__radio input:checked').value;

            console.log(form);
            console.log(answerId);
            console.log(answerValue);

            initUpdatePoll(form,answerValue,answerId);
        };

    });

    document.addEventListener('click', e => {
        if (e.target.closest('.poll-container .btn--results')) {
            const form = e.target.closest('.poll-container').dataset.poll;
            console.log(form);
            // initPollResults(112589);
        };

    });




    //Tabs
    const buttons = document.querySelectorAll("button");
    const sections = document.querySelectorAll(".content");


    buttons.forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            buttons.forEach((btn)=>{
                btn.classList.remove("active");
            });
            btn.classList.add("active");
            const id = btn.id;
            sections.forEach((section)=>{
                section.classList.remove("active");
            });
            const req = document.getElementsByClassName(`content${id}`);
            req[0].classList.add("active");
        })
    })

    // Anchor scroll to
    const header = document.querySelector('#header'),
        scroll_correction = (header ? header.offsetHeight : 0) + 70;
    new AnchorScroll('.page-content a[href^="#"]:not(.carousel__control)', scroll_correction);

    const polls = document.querySelectorAll('.poll-container');
    polls && polls.forEach(poll => {
        poll.style.height = poll.offsetHeight + 'px';
    });

    document.addEventListener('click', e => {
        if (!e.target.closest('[data-open]')) return;
        showElement(e.target.closest('[data-open]'));
    });

    document.addEventListener('click', e => {
        const openned_modal = document.querySelector('.modal.show');
        if (e.target.closest('[data-close]')) {
            HideElement(e.target.closest('[data-close]'));
        } else if (e.target == openned_modal) {
            HideElement(openned_modal);
        }
    });

    document.addEventListener('click', e => {
        if (!e.target.closest('[data-togle]')) return;
        toggleElement(e.target.closest('[data-togle]'));
    });

    const contact_forms = document.querySelectorAll('form');
    contact_forms.length && contact_forms.forEach(contact_form => {
        contact_form.setAttribute('autocomplete', 'off');
    });

    // Show fixed banner on mobiles
    const banners = document.querySelectorAll('.show-item, .item__show');
    banners.forEach(banner => {
        banner.firstElementChild.style.display === 'none' ? banner.style.display = 'none' : '';
    });


    // Mobile popup banner
    if (window.matchMedia('(max-width: 575px)').matches) {
        setTimeout(() => {
            const modal = document.querySelector('.show-item--mobile');
            if (!modal) {
                return;
            }
            const ad = modal.lastElementChild;

            if (ad.style.display === 'none') {
                modal.style.display = 'none';
                return;
            }

            modal.classList.add('show');
        }, 3000);
    }

    if (window.matchMedia('(min-width: 575px)').matches) {
        setTimeout(() => {
            const modal = document.querySelector('.show-item--big-screen');
            if (!modal) {
                return;
            }
            const ad = modal.lastElementChild;

            if (ad.style.display === 'none') {
                modal.style.display = 'none';
                return;
            }

            modal.classList.add('show');
        }, 3000);
    }

    function bannerPosition() {
        if (!window.matchMedia('(min-width: 576px)').matches) return;

        const header = document.querySelector('#header'),
            banners = document.querySelectorAll('.bkgbrand'),
            slider = document.querySelector('.after__header'),
            single_header = document.querySelector('.single-post__header');

        if (!banners.length) {
            return;
        }

        const header_height = header.offsetHeight;
        let height_to_scroll = (slider ? slider.offsetHeight : 0) + (single_header ? single_header.offsetHeight : 0);
        height_to_scroll = height_to_scroll <= 0 ? 0 : height_to_scroll - header_height;

        if (window.scrollY > height_to_scroll) {
            banners.forEach(banner => banner.style.top = header_height + 'px');
        } else if (single_header) {
            banners.forEach(banner => banner.style.top = `${header_height + single_header.offsetHeight}px`);
        } else {
            banners.forEach(banner => banner.style.top = 'unset');
        }

        requestAnimationFrame(bannerPosition);
    }

    requestAnimationFrame(bannerPosition);

    // Form animation control on sending
    const contact_form = document.querySelector('.wpcf7');
    if (contact_form) {
        const submit_btn = contact_form.querySelector('[type="submit"]');

        submit_btn.addEventListener('click', function () {
            this.classList.add('loading');
        });

        contact_form.addEventListener('wpcf7submit', () => {
            setTimeout(() => submit_btn.classList.remove('loading'), 300);
        });
    }

    const cookie_consent = new Cookie({
        cookieName: 'cookie_consent',
        cookieValue: 'accepted',
        cookieExpire: 30,
        cookieContainer: '.cookie'
    });
    cookie_consent.init();

    const ebook_cookie = new Cookie({cookieName: 'ebook', cookieValue: 'closed', cookieExpire: 5});

    if (window.matchMedia('(min-width: 992px)').matches && document.querySelector('.toast .btn--close') && !ebook_cookie.getCookie(ebook_cookie.cookieName)) {
        document.addEventListener('click', e => {
            if (!e.target.closest('.toast .btn--close, .toast .btn--blue')) return;
            ebook_cookie.setCookie();
        });

        // Toasts
        // new Toast('.toast');
    }

    // Newsletter
    const newsletter = document.querySelector('#sib-form');

    if (newsletter) {
        const error_res = document.querySelector('.sib-form #error-message'),
            success_res = document.querySelector('.sib-form #success-message');

        newsletter.addEventListener('submit', e => {
            e.preventDefault();

            const btn = newsletter.querySelector('.btn[type="submit"]'),
                newsletter_inputs = Array.from(newsletter.elements),
                data = CreateFormData(newsletter_inputs);

            newsletter_inputs.forEach(input => input.classList.remove('invalid'));

            if (!newsletter_inputs.filter(input => input.value)) {
                newsletter_inputs.forEach(input => {
                    if (input.value == '') {
                        input.classList.add('invalid');
                    }
                });
                return;
            }

            btn && btn.classList.add('loading');

            fetch(newsletter.action + '?isAjax=1', {
                method: 'post',
                body: data
            })
                .then(res => res.json())
                .then(json => {
                    if (json.success) {
                        success_res.classList.add('sib-form-message-panel--active');

                        newsletter_inputs.forEach(input => {
                            input.value = '';
                        });

                        if (newsletter.dataset.hasOwnProperty('redirect')) {
                            window.location.href = newsletter.dataset.redirect;
                        }
                    } else {
                        error_res.classList.add('sib-form-message-panel--active');
                    }

                    btn.classList.remove('loading');
                })
                .catch(err => {
                    console.error('Dogodila se greška prilikom prijave: ', err);
                    error_res.classList.add('sib-form-message-panel--active');

                    btn.classList.remove('loading');
                });

        });
    }

    // E-book download
    const ebook_link = document.querySelector('.mc4wp-form a.btn--blue');
    ebook_link && ebook_link.addEventListener('click', function (e) {
        e.preventDefault();

        const form_el = this.closest('form'),
            form_elements = Array.from(form_el.elements);
        let invalid_fields = 0;

        form_elements.forEach(el => {
            if (el.required && el.value === '') {
                invalid_fields++;
                el.classList.add('invalid');
                return;
            }

            el.classList.remove('invalid');
        });

        if (!invalid_fields) {
            form_el.submit();
            window.open(this.href, '_blank');
        }
    });


    if (document.getElementById('dimenzija')) {
        document.getElementById('dimenzija').addEventListener('change', function (e) {
            setTimeout(function () {
                let change = document.querySelector('.single_change .amount'),
                    change_bdi = document.querySelector('.single_change bdi'),
                    price = document.querySelectorAll('.variations_form .single_variation_wrap .price .amount bdi')[0];

                change.removeChild(change_bdi);
                change.append(price);
            }, 200)
        })
    }

    if (document.querySelector('#search-form-header')) {
        document.querySelector('.search_panel_click').addEventListener('click', function () {
            document.querySelector('#search-form-header').classList.toggle('show');
        })
    }

    // if (document.querySelector('#pop-up-newsletter')) {
    //     document.querySelector('.search_panel_click').addEventListener('click', function () {
    //         document.querySelector('#pop-up-newsletter').classList.toggle('show');
    //     })
    // }

    instant_defer();
});



// WEBPACK FOOTER //
// ./scripts/modules/global.js